import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appFVWrapper]',
})
export class ControlWrapperDirective {
  constructor(public vcr: ViewContainerRef) {}
}
